import { render, staticRenderFns } from "./GoToMasterLesson.vue?vue&type=template&id=1d07406e&lang=pug&"
import script from "./GoToMasterLesson.vue?vue&type=script&lang=ts&"
export * from "./GoToMasterLesson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports